var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 112.237H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 112.237z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 112.231h512v23.96H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 136.201h512v23.96H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 160.151h512v23.96H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 184.121h512v23.96H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 208.081h512v23.96H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 232.041h512v23.96H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 256.001h512v23.96H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M512 303.923H0v-39.094h8.828l.002 15.132H512z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 303.921h512v23.96H0z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 327.881h512v23.96H0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 351.851h512v23.96H0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 375.801h512v23.96H0z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897v-15.133h512v15.133a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#f5f5f5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.966 279.961H8.828A8.829 8.829 0 0 1 0 271.133V97.104a8.829 8.829 0 0 1 8.828-8.828h300.138a8.829 8.829 0 0 1 8.828 8.828v174.029a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#41479b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.862 184.023c0-33.387 27.1-60.47 60.456-60.47a60.147 60.147 0 0 1 23.641 4.814c.943.402 1.654-.911.807-1.489-12.025-8.186-26.731-12.671-42.505-11.851-34.679 1.803-63.036 29.736-65.278 64.39-2.607 40.308 29.289 73.699 68.959 73.699 14.336 0 27.662-4.417 38.729-11.906.852-.577.146-1.892-.801-1.491a60.142 60.142 0 0 1-23.55 4.776c-33.358-.001-60.458-27.084-60.458-60.472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.061 184.023l25.558-9.889c1.263-.489.833-2.376-.518-2.268l-27.308 2.187 18.766-20.06c.926-.989-.28-2.5-1.45-1.818l-23.718 13.836 8.186-26.176c.404-1.292-1.338-2.131-2.095-1.009l-15.354 22.745-3.939-27.148c-.194-1.341-2.13-1.342-2.326-.001l-2.516 17.178-1.044 7.27-.402 2.702-15.354-22.726c-.758-1.122-2.502-.282-2.095 1.01l8.216 26.154-23.716-13.836c-1.17-.683-2.376.829-1.45 1.818l18.765 20.06-27.315-2.187c-1.351-.108-1.782 1.779-.518 2.268l25.581 9.889-25.582 9.891c-1.265.489-.833 2.376.518 2.268l27.316-2.187-18.766 20.11c-.925.991.284 2.5 1.453 1.816l23.715-13.885-8.216 26.154c-.406 1.292 1.336 2.133 2.095 1.01l15.354-22.726.402 2.766 1.044 7.206 2.517 17.224c.196 1.342 2.132 1.34 2.326-.001l3.939-27.193 15.354 22.745c.758 1.122 2.5.285 2.095-1.009l-8.186-26.176 23.715 13.885c1.169.684 2.377-.825 1.453-1.816l-18.767-20.11 27.309 2.187c1.351.108 1.782-1.779.518-2.268l-25.56-9.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.86183446da4843b6d0ec8b95b3c97757.svg";
export { ForwardRef as ReactComponent };